import { WSLItem } from "../../../interfaces/Stocks/wslitems"

interface ViewWSLItemsProps {
  WSLItemPayload: WSLItem,
  setOpenDialog: (open: boolean) => void,
}

export const ViewWSLItems = ({
  WSLItemPayload,
  setOpenDialog,
}: ViewWSLItemsProps) => {
  return (
    <>
    </>
  )
}
